import { useParams, usePathname } from 'next/navigation';

const usePathnameWithoutLocale = () => {
  const pathname = usePathname();
  const { locale } = useParams<{ locale: string }>();
  return `${pathname.replace(locale, '').replace('//', '/')}`;
};
export default usePathnameWithoutLocale;
